import { useAppSelector } from 'commons/store/hooks';
import React from 'react';
import { StyledSurveySegments, StyledSurveySegmentsItem } from '../Form.styled';
import { ROUTES_SURVEY } from "commons/constants/paths";
import { useNavigate, useParams } from "react-router-dom";
import { selectSegments } from "../../../redux/surveySlice";

interface Props {
    selectedSegment: any;
    setSelectedSegment: (selectedSegment: any) => void;
    isDataLoading: boolean;
}

export const SegmentsPanel: React.FC<Props> = ({
    selectedSegment,
    setSelectedSegment,
    isDataLoading
}) => {
    const navigate = useNavigate();
    const segments = useAppSelector(selectSegments);
    const { id } = useParams<{ id: string }>();

    const handleClick = async (segment: any) => {
        if (isDataLoading) return;

        setSelectedSegment(segment);
        (id && segment?.sections[0]?.id) && navigate(ROUTES_SURVEY.DETAILS_EXTENDED(id, segment?.sections[0]?.id));
    };

    return (
        <StyledSurveySegments>
            {segments.map((segments: any) => (
                <StyledSurveySegmentsItem
                    key={segments?.id}
                    onClick={() => {handleClick(segments)}}
                    selected={selectedSegment?.id === segments?.id}
                >
                    {segments?.name}
                </StyledSurveySegmentsItem>
            ))}
        </StyledSurveySegments>
    );
};
